import axios from 'axios';

class Newsletter {
    constructor({ form }) {
        this.form = form;
        this.input = form.querySelector('input[type="email"]');
        this.action = form.dataset.action;

        this.events();
    }

    events() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();

            this.setState('loading');

            // Convert FormData to JSON
            const data = Array.from(new FormData(this.form).entries()).reduce(
                (memo, pair) => ({
                    ...memo,
                    [pair[0]]: pair[1]
                }),
                {}
            );

            axios
                .post(this.action, data)
                .then((response) => {
                    if (response.data.success) {
                        this.setState('success');
                        this.setMessage(response.data.message);
                        this.form.reset();
                    } else {
                        this.setState('invalid');
                        this.setMessage(
                            response.data.message ||
                                'We are having trouble adding you to the list.<br>Have you already subscribed?'
                        );
                    }
                })
                .catch(() => {
                    this.setState('invalid');
                    this.setMessage('Server error. Please try again later.');
                });
        });
    }

    setState(state) {
        this.form.classList.add(`Subscribe--${state}`);

        this.input.addEventListener(
            'keydown',
            () => {
                this.setState('valid');
            },
            { once: true }
        );
    }

    setMessage(message) {
        const messageDiv = this.form.querySelector('.SubscribeMessage');
        messageDiv.innerHTML = message;
    }
}

export default (() => {
    const subscribeForms = document.querySelectorAll('.Subscribe');

    subscribeForms.forEach((form) => {
        new Newsletter({ form });
    });
})();
